module.exports = __webpack_public_path__ + "static/media/notAllowed.fb344c0c.svg";